import { render, staticRenderFns } from "./ModuleEdit.vue?vue&type=template&id=6cb43003"
import script from "./ModuleEdit.vue?vue&type=script&lang=js"
export * from "./ModuleEdit.vue?vue&type=script&lang=js"
import style0 from "./ModuleEdit.vue?vue&type=style&index=0&id=6cb43003&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports